import { PRODUCT_PLANS } from '../productPlan';
import type { SelfSignUpForm } from '../types';
import type { Steps } from './validateFormFields';

type FieldRequirement<T> = T extends Record<string, unknown>
  ? boolean | Partial<Record<keyof T, boolean>>
  : boolean;

export type FormFieldRequirements = {
  [K in keyof SelfSignUpForm]?: FieldRequirement<NonNullable<SelfSignUpForm[K]>>;
};

type PlanStepConfig = {
  requiredFields: FormFieldRequirements;
};

type PlanConfig = Partial<Record<Steps, PlanStepConfig>>;

const RESTAURANT_INFO_REQUIRED: FormFieldRequirements = {
  address: {
    city: true,
    postalCode: true,
    street: true,
  },
  email: true,
  firstName: true,
  lastName: true,
  locations: true,
  phone: {
    inputValue: true,
    phone: true,
  },
  restaurantName: true,
};

const DEFAULT_PLAN = 'starter';

const PLAN_CONFIGS: Record<string, PlanConfig> = {
  menu_embed: {
    restaurant_info_step: {
      requiredFields: RESTAURANT_INFO_REQUIRED,
    },
  },
  starter: {
    restaurant_info_step: {
      requiredFields: RESTAURANT_INFO_REQUIRED,
    },
  },
  [PRODUCT_PLANS.sysco]: {
    restaurant_info_step: {
      requiredFields: {
        ...RESTAURANT_INFO_REQUIRED,
        opco: true,
        partnerEmail: true,
        partnerFirstName: true,
        partnerLastName: true,
      },
    },
  },
};

function getConfig(productPlan?: string): PlanConfig {
  return (PLAN_CONFIGS[productPlan ?? DEFAULT_PLAN] ?? PLAN_CONFIGS[DEFAULT_PLAN]) as unknown as PlanConfig;
}

export function getRequiredFields(productPlan: string | undefined, step: Steps): FormFieldRequirements {
  return getConfig(productPlan)[step]?.requiredFields ?? {};
}
